import type { JSX } from "react";
import { OfflineBanner } from "./OfflineBanner";
import { SyncStatus } from "./SyncStatus";

export interface GlobalStatusBarProps {
  variant?: "app" | "auth";
}

export function GlobalStatusBar({ variant = "app" }: GlobalStatusBarProps): JSX.Element {
  return (
    <div data-testid="global-status-bar">
      <OfflineBanner variant={variant} />
      <SyncStatus />
    </div>
  );
}
